export default "__VITE_ASSET__ClxsiVze__"